import * as React from 'react'

import { cn } from '@/shared/lib/utils'

const Textarea = React.forwardRef<HTMLTextAreaElement, React.ComponentProps<'textarea'>>(
  ({ className, ...props }, ref) => {
    return (
      <textarea
        ref={ref}
        data-slot="textarea"
        className={cn(
          'flex min-h-[112px] w-full min-w-0 rounded-field border border-input bg-[var(--bg-light)] px-2.5 py-2 text-[13px] leading-5 transition-colors outline-none placeholder:text-muted-foreground focus-visible:border-[var(--green)] disabled:pointer-events-none disabled:cursor-not-allowed disabled:bg-input/50 disabled:opacity-50 aria-invalid:border-destructive resize-none',
          className,
        )}
        {...props}
      />
    )
  },
)

Textarea.displayName = 'Textarea'

export { Textarea }
